import { PricingType, PerksPricingType } from '../types';

export const getProductPricing = ({
  pricing,
  shouldShowWasPrice,
  perksPricing,
  isPerksMember,
  showPerksPrice,
  shouldHidePerksExclusiveDealsFromNonMembers,
}: {
  pricing: PricingType;
  shouldShowWasPrice?: boolean;
  perksPricing?: PerksPricingType;
  isPerksMember?: boolean;
  showPerksPrice?: boolean;
  shouldHidePerksExclusiveDealsFromNonMembers?: boolean;
}) => {
  if (!pricing) return;
  const { displayPriceAfterCashback, wasPrice, priceAfterCashback, displayPriceInc, displayWasPrice } = pricing;
  const isEarlyAccess = !!perksPricing?.promoNamesApplied?.find(status => status.includes('JBPEAR'));
  const isExclusiveDeal = !!perksPricing?.promoNamesApplied?.find(status => status.includes('JBPEXC'));
  const hasPerksPromotion = isEarlyAccess || isExclusiveDeal;
  const perksPrice =
    isExclusiveDeal && (!shouldHidePerksExclusiveDealsFromNonMembers || isPerksMember)
      ? perksPricing?.displayPriceInc
      : 0;
  let ticketPrice = 0;
  let actualPrice =
    isEarlyAccess && !isExclusiveDeal && isPerksMember ? perksPricing?.displayPriceInc : displayPriceInc;
  if (!hasPerksPromotion && showPerksPrice && isPerksMember && perksPricing?.displayWasPrice) {
    ticketPrice = perksPricing.wasPrice;
    actualPrice = perksPricing.displayPriceInc;
  } else if (!hasPerksPromotion || (isEarlyAccess && !isPerksMember)) {
    if (displayPriceAfterCashback) {
      ticketPrice = displayPriceInc;
      actualPrice = priceAfterCashback ?? 0;
    } else if (showPerksPrice && shouldShowWasPrice && isPerksMember) {
      ticketPrice = 0;
    } else if (shouldShowWasPrice) {
      ticketPrice = wasPrice ?? 0;
    }
  } else if ((isExclusiveDeal && perksPricing) || (isEarlyAccess && isExclusiveDeal && perksPricing)) {
    if (perksPricing.displayPriceAfterCashback) {
      ticketPrice = displayPriceInc;
    } else if (perksPricing.displayWasPrice && wasPrice) {
      ticketPrice = displayWasPrice ? wasPrice : displayPriceInc;
      actualPrice = displayPriceInc;
    }
  } else if (isEarlyAccess && isPerksMember && perksPricing) {
    if (perksPricing.displayPriceAfterCashback) {
      ticketPrice = perksPricing.displayPriceInc;
    } else if (perksPricing.displayWasPrice) {
      ticketPrice = perksPricing.wasPrice ?? displayPriceInc;
    }
  }
  return {
    ticket: ticketPrice,
    actual: actualPrice ?? displayPriceInc,
    cashback: hasPerksPromotion ? perksPricing?.displayPriceAfterCashback : displayPriceAfterCashback,
    perks: perksPrice,
  };
};
